import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Audience } from './components/Audience';
import { Tomos } from './components/Tomos';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Implementation (ID: 1252242806993118)
    const pixelId = '1252242806993118';
    try {
      // @ts-ignore
      if (!window.fbq) {
        // @ts-ignore
        const n: any = window.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        // @ts-ignore
        window._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      // @ts-ignore
      window.fbq('init', pixelId);
      // @ts-ignore
      window.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-crema font-sans selection:bg-bordo selection:text-crema" data-id="element-0">
      <Hero data-id="element-1" />
      <Audience data-id="element-2" />
      <Tomos data-id="element-3" />
      <Testimonials data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <PurchasePopup data-id="element-7" />
    </div>;
}